export default __webpack_public_path__ + "static/media/lottery.5b0da915.PNG";